import { NavList } from '@cpm-pr1618001/ng-design-lib';

export const DASHBOARD_NAVIGATION_LIST: NavList[] = [
  { name: 'Home', id: 0, url: 'home' },
  { name: 'Savings', id: 1, url: 'savings' },
  { name: 'Stocks', id: 2, url: 'stocks' },
  { name: 'Credit cards', id: 3, url: 'credit-cards' },
  { name: 'Loans', id: 4, url: 'loans' },
  { name: 'Expenses', id: 5, url: 'expenses' },
];
